import { useCallback } from "react";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { useMedicalCareContext } from "@/contexts/MedicalCareContext";
import { useSessionContext } from "@/contexts/SessionContext";
import { PostResultJson } from "@/services/fhir/patientsummary/documentreference/PostResultJson";
import { useFhirData } from "@/utils/useFhirData";

interface UseExamSaveProps {
  onSuccess?: () => void;
}

export const useExamSave = ({ onSuccess }: UseExamSaveProps = {}) => {
  const { summaryData, patient, setRefetch } = useMedicalCareContext();
  const { user } = useSessionContext();

  const handleSaveExam = useCallback(
    async (documentReferenceId: string, fileBase64: string) => {
      if (!patient) {
        toast.error("Dados do paciente não encontrados");
        return false;
      }

      // if (!appointment) {
      //   toast.error("Dados do agendamento não encontrados");
      //   return false;
      // }

      try {
        // Buscar documentos de solicitação
        const documentReference = useFhirData.extractPatientSummaryResource(
          summaryData,
          "DocumentReference",
          "service-request"
        )?.[0]?.entry;

        // Buscar o documento específico
        const selectedDoc = documentReference?.find(
          (doc: any) => doc.resource.id === documentReferenceId
        );

        if (!selectedDoc) {
          toast.error("Documento de solicitação não encontrado");
          return false;
        }

        const docReferenceData = {
          servicePratice: {
            code: selectedDoc.resource?.practiceSetting?.coding?.[0]?.code,
            system: selectedDoc.resource?.practiceSetting?.coding?.[0]?.system,
            display:
              selectedDoc.resource?.practiceSetting?.coding?.[0]?.display,
          },
          time: {
            start: dayjs().toISOString(),
            end: dayjs().toISOString(),
          },
        };

        const dataWithBase64 = {
          ...docReferenceData,
          base64: fileBase64?.split(",")?.[1],
          codeValue: "RESULT",
          codeDisplay: "Resultado de exame",
          categoryValue: "resultado",
          categoryDisplay: "Resultado de exame",
        };

        const encounterReference = {
          id: selectedDoc.resource?.context
            ?.find((el: any) => el?.reference?.includes("Encounter"))
            ?.reference?.split("/")?.[1],
          subject: user?.username,
          appointmentId: selectedDoc.resource?.context
            ?.find((el: any) => el?.reference?.includes("Appointment"))
            ?.reference?.split("/")?.[1],
        };

        const basedOnReference = selectedDoc.resource?.basedOn?.filter(
          (el: any) => el.reference?.includes("ServiceRequest")
        );

        await PostResultJson(
          dataWithBase64,
          encounterReference,
          basedOnReference
        );

        toast.success("Resultado do exame enviado com sucesso!");
        setRefetch(true);
        onSuccess?.();
        return true;
      } catch (error: any) {
        console.error("Erro ao enviar resultado:", error);
        const errorMessage =
          error.response?.data?.message ||
          "Erro ao enviar o resultado do exame";
        toast.error(errorMessage);
        return false;
      }
    },
    [summaryData, patient, setRefetch, user?.username, onSuccess]
  );

  return {
    handleSaveExam,
  };
};
